import { useLang } from "@/context/LangContext";
import { MAP_PARTY_COLORS, NO_DATA_COLOR, OUTCOME_COLORS, OUTCOME_ORDER, partyLabel } from "@/lib/insights";

export default function MapLegend({ seats, mode }) {
  const { t, lang } = useLang();
  const ta = lang === "ta";
  const counts = {};
  for (const s of seats) {
    const k = mode === "change" ? s.outcome_key : s.y2026?.party_short || "none";
    counts[k] = (counts[k] || 0) + 1;
  }
  const keys = mode === "change"
    ? OUTCOME_ORDER.filter((k) => counts[k])
    : Object.keys(counts).sort((a, b) => (a === "none") - (b === "none") || counts[b] - counts[a]);

  const label = (k) => {
    if (mode === "change") return t(`outcome_${k}`);
    return k === "none" ? t("not_listed") : partyLabel(k, lang);
  };
  const color = (k) => (mode === "change" ? OUTCOME_COLORS[k] : MAP_PARTY_COLORS[k] || NO_DATA_COLOR);

  return (
    <div className="flex flex-wrap gap-2" data-testid="map-legend">
      {keys.map((k) => (
        <span
          key={k}
          className={`inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1.5 text-[12px] font-semibold text-[#1a1640] shadow-sm ${ta ? "font-tamil" : ""}`}
          data-testid={`map-legend-${k}`}
        >
          <span className="w-3 h-3 rounded-sm" style={{ background: color(k) }} />
          {label(k)}
          <span className="text-[#6b6894] font-bold tabular-nums">{counts[k]}</span>
        </span>
      ))}
    </div>
  );
}
